<script>
  import { slide } from 'svelte/transition';
  export let entry;
  let isOpen = false;
  const toggle = () => (isOpen = !isOpen);
</script>

<button on:click={toggle} aria-expanded={isOpen}>
  {entry[0]}
  <svg
    style="tran"
    width="12"
    height="12"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="2"
    viewBox="0 0 24 24"
    stroke="currentColor"><path d="M9 5l7 7-7 7" /></svg
  >
</button>
{#if isOpen}
  <p transition:slide={{ duration: 300 }}>
    {@html entry[1]}
  </p>
{/if}
<span class="accordion-line" />

<style>button{background:none;border:none;color:inherit;cursor:pointer;display:block;display:flex;font-size:1em;justify-content:space-between;margin:0;padding:1em 0;text-align:left;width:100%}svg{transition:transform .2s ease-in}[aria-expanded=true] svg{transform:rotate(90deg)}p{font-size:.9rem;margin-bottom:.5rem;padding-left:.5em}.accordion-line{background-color:#d0d0d2;display:block;height:1px;margin:0 -1em;width:calc(100% + 2em)}</style>
